import React, { useEffect, useState } from "react";

import ToastDashboardSplashImageUrl from "images/logos/png/toast_dashboard_splash_image.png";
import ToastDashboardSplashImageMobileUrl from "images/logos/png/toast_dashboard_splash_image_mobile.png";
import ToastQuoteSplashImageUrl from "images/logos/png/toast_quote_splash_image.png";
import ToastQuoteSplashImageMobileUrl from "images/logos/png/toast_quote_splash_image_mobile.png";

import { Body1 } from "Cobalt/BodyText";
import Button from "Cobalt/Button";
import { Title } from "Cobalt/Header";
import { ModalBody, ModalHeader, Modal } from "Cobalt/Modal";
import BodyText from "Common/BodyText";

const NewWindowForAuth = () => {
  const popupWidth = 500;
  const popupHeight = 600;
  const left = window.screen.width / 2 - popupWidth / 2;
  const top = window.screen.height / 2 - popupHeight / 2;

  let subdomain;
  if (window.location.href.includes("staging")) {
    subdomain = "staging";
  } else if (process.env.NODE_ENV === "production") {
    subdomain = "www";
  } else {
    subdomain = "localapi";
  }

  const siBaseUrl = `https://${subdomain}.simplyinsured.com`;
  const popup = window.open(
    `${siBaseUrl}/toast_connect_benefits${location.search}`,
    "LoginPopup",
    `width=${popupWidth},height=${popupHeight},left=${left},top=${top},toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes`,
  );

  if (!popup || popup.closed || typeof popup.closed === "undefined") {
    alert("Popup blocked! Please enable popups for this site to log in.");
    return;
  }

  // Listen for messages from the popup
  window.addEventListener("message", function handleMessage(event) {
    // Validate the origin of the message
    if (event.origin !== siBaseUrl) {
      console.warn("Message received from untrusted origin:", event.origin);
      return;
    }

    // Ensure the message contains the expected URL
    const receivedUrl = event.data.url;
    if (receivedUrl) {
      // Close the popup
      popup.close();
      // redirect to the received URL
      window.location.href = `${receivedUrl}`;
      // Remove the message listener after receiving the data
      window.removeEventListener("message", handleMessage);
    }
  });

  return null;
};

const getEnrollmentStatus = async () => {
  const params = Object.fromEntries(new URLSearchParams(window.location.search));
  const { customer_uuid } = params;

  if (!customer_uuid) {
    return false;
  }

  const encodedCustomerUuid = encodeURIComponent(customer_uuid);
  const response = await fetch(`/toast/router/enrollment_status/${encodedCustomerUuid}`, {
    headers: { Accept: "application/json" },
  });

  if (!response.ok) {
    return false;
  }

  const data = await response.json();
  return data.enrolled;
};

const LaunchSimplyInsured = () => {
  const [enrolled, setEnrolled] = useState(null);

  const backgroundImageUrl = enrolled ? ToastDashboardSplashImageUrl : ToastQuoteSplashImageUrl;
  const backgroundImageMobileUrl = enrolled ? ToastDashboardSplashImageMobileUrl : ToastQuoteSplashImageMobileUrl;

  const styles = {
    background: {
      backgroundImage: `url(${backgroundImageUrl})`,
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "top center",
      height: "100vh",
    },
    mobileBackground: {
      backgroundImage: `url(${backgroundImageMobileUrl})`,
      backgroundSize: "contain",
    },
  };

  useEffect(() => {
    const loadEnrollmentStatus = async () => {
      try {
        const enrolledStatus = await getEnrollmentStatus();
        setEnrolled(enrolledStatus);
      } catch {
        setEnrolled(false);
      }
    };
    loadEnrollmentStatus();
  }, []);

  if (enrolled === null) {
    return null;
  }

  const titleString = enrolled ? "Connect to your employer dashboard" : "Continue to your quote";
  const btnString = enrolled ? "Connect and continue" : "Continue";

  return (
    <>
      <div
        style={{
          ...styles.background,
          ...(window.innerWidth < 768 ? styles.mobileBackground : {}),
        }}
      />
      <Modal show>
        <ModalHeader className="justify-center">
          <Title>{titleString}</Title>
        </ModalHeader>
        <ModalBody className="justify-center text-center">
          {!enrolled && (
            <BodyText>
              <Body1 mb={5}>We’ll briefly connect to get your information and personalize your plan options.</Body1>
            </BodyText>
          )}
          <Button size="large" onClick={() => NewWindowForAuth()}>
            {btnString}
          </Button>
        </ModalBody>
      </Modal>
    </>
  );
};

export default LaunchSimplyInsured;
